// extracted by mini-css-extract-plugin
export default {"header":"pqv7zMR4_o6emgE_3UsN"};